import { isValidCitySlug } from "@shared/formats/city";

export function buildStatePageUrl(
  productSlug: string,
  stateSlug: string,
): string {
  return `/buy-${productSlug}/${stateSlug}`;
}

export function buildCityPageUrl(
  productSlug: string,
  stateSlug: string,
  citySlug: string,
): string {
  return `/buy-${productSlug}/${stateSlug}/${citySlug}`;
}

export function buildProductPageUrl(productSlug: string): string {
  return `/buy-${productSlug}`;
}

export function canBuildCityPageUrl(
  productSlug: string | null | undefined,
  stateSlug: string | null | undefined,
  citySlug: string | null | undefined,
): boolean {
  if (!productSlug || !stateSlug || !citySlug) return false;
  if (!isValidCitySlug(citySlug)) return false;
  return true;
}

export function canBuildStatePageUrl(
  productSlug: string | null | undefined,
  stateSlug: string | null | undefined,
): boolean {
  return !!(productSlug && stateSlug);
}

export interface SearchUrlParams {
  postalCode: string;
  lat: number;
  lng: number;
  quantity: number;
  productType?: string | null;
  deliveryDate?: Date | null;
}

export interface SearchUrlLocationData {
  stateSlug?: string | null;
}

export function buildSearchResultsUrl(
  location: SearchUrlLocationData | null,
  params: SearchUrlParams,
): string {
  if (!location) return "/listing";

  const stateSlug = location.stateSlug?.toLowerCase() || "";
  if (!stateSlug) return "/listing";

  const baseUrl = params.productType
    ? `/buy-${params.productType}/${stateSlug}`
    : `/buy-pallets/${stateSlug}`;

  const searchParams = new URLSearchParams();
  searchParams.set("zip", params.postalCode);
  searchParams.set("lat", params.lat.toString());
  searchParams.set("lng", params.lng.toString());
  searchParams.set("qty", params.quantity.toString());

  if (params.deliveryDate) {
    const year = params.deliveryDate.getFullYear();
    const month = String(params.deliveryDate.getMonth() + 1).padStart(2, "0");
    const day = String(params.deliveryDate.getDate()).padStart(2, "0");
    searchParams.set("date", `${year}-${month}-${day}`);
  }

  if (params.productType) {
    searchParams.set("product", params.productType);
  }

  return `${baseUrl}?${searchParams.toString()}`;
}
